import { combineEpics } from 'redux-observable';

import type { Action } from '../state/actions';
import type { State } from '../state/reducer';
import createComponent from './create';
import { successfulDelete } from './delete';
import { queryPatched } from './query-patched';
import { querySet } from './query-set';
import { retrieveComponents } from './retrieve';
import { updateComponent, initiateUpdateComponent } from './update';

export default combineEpics<Action, State>(
	retrieveComponents,
	createComponent,
	updateComponent,
	initiateUpdateComponent,
	successfulDelete,
	querySet,
	queryPatched,
);
